<template>
  <div>
    <div class="row mb-1 mb-lg-2 mb-xl-4">
      <div class="col-md-6">
        <slot name="title"/>
      </div>
      <div class="col-6 align-self-end d-none d-md-block">
        <div class="ce-roadmap-nav">
          <button type="button" class="btn btn-icon swiper-button swiper-button-prev" :class="'ce-roadmap--prev-' + uid">
            <slot name="nav-icon"/>
            <span class="visually-hidden">Previous slide</span>
          </button>
          <button type="button" class="btn btn-icon swiper-button swiper-button-next" :class="'ce-roadmap--next-' + uid">
            <slot name="nav-icon"/>
            <span class="visually-hidden">Next slide</span>
          </button>
        </div>
      </div>
    </div>
    <swiper v-bind="swiperOptions">
      <slot name="slides"/>
      <div v-if="pagination" class="swiper-custom-pagination ce-roadmap-pagination"/>
    </swiper>
    <div class="d-flex justify-content-end d-md-none">
      <div class="ce-roadmap-nav">
        <button type="button" class="btn btn-icon swiper-button swiper-button-prev" :class="'ce-roadmap--prev-' + uid">
          <slot name="nav-icon"/>
          <span class="visually-hidden">Previous slide</span>
        </button>
        <button type="button" class="btn btn-icon swiper-button swiper-button-next" :class="'ce-roadmap--next-' + uid">
          <slot name="nav-icon"/>
          <span class="visually-hidden">Next slide</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';

import { Swiper } from 'swiper/vue';

SwiperCore.use([Navigation, Pagination]);

export default {
  components: {
    'swiper': Swiper
  },
  props: {
    pagination: {
      type: Boolean,
      default: false,
    },
    uid: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      swiperOptions: {
        speed: 500,
        threshold: 10,
        watchOverflow: true,
        followFinger: true,
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          prevEl: `.ce-roadmap--prev-${this.uid}`,
          nextEl: `.ce-roadmap--next-${this.uid}`,
        },
        pagination: {
          el: '.ce-slider-pagination',
          clickable: true,
        },
        breakpoints: {
          992: {
            spaceBetween: 24
          }
        }
      },
    };
  },
  mounted() {
    this.$root.lazyLoad.update();
  }
};
</script>
